/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { Warehouse } from '../../types';
import { CreateWarehouseAction, CreateWarehouseActionTypes } from './types';

export interface CreateWarehouseState {
  warehouse?: Warehouse;
  success: boolean;
  loading: boolean;
  error?: Error;
}

export const initialCreateWarehouseState: CreateWarehouseState = {
  warehouse: undefined,
  success: false,
  loading: false,
  error: undefined,
};

export default function createWarehouseReducer(state = initialCreateWarehouseState, action: CreateWarehouseAction) {
  switch (action.type) {
    case CreateWarehouseActionTypes.CREATE_WAREHOUSE:
      return update(state, {
        success: { $set: false },
        loading: { $set: true },
        $unset: ['error'],
      });

    case CreateWarehouseActionTypes.CREATE_WAREHOUSE_SUCCESS:
      return update(state, {
        success: { $set: true },
        loading: { $set: false },
        warehouse: { $set: action.warehouse },
        $unset: ['error'],
      });

    case CreateWarehouseActionTypes.CREATE_WAREHOUSE_ERROR:
      return update(state, {
        success: { $set: false },
        loading: { $set: false },
        error: { $set: action.error },
      });

    case CreateWarehouseActionTypes.CREATE_WAREHOUSE_RESET_ERROR:
      return update(state, {
        $unset: ['error'],
      });

    case CreateWarehouseActionTypes.CREATE_WAREHOUSE_RESET_STATE:
      return initialCreateWarehouseState;

    default:
      return state;
  }
}
